module.exports = __webpack_public_path__ + "8c7e75d0f2c5ef59a471ff1b30fa4ed6.svg";